import { motion } from "framer-motion";

const CLIENTS = [
  { name: "Unspeakable", subs: "19M", img: "/media/client-unspeakable.jpg" },
  { name: "Shark", subs: "5M", img: "/media/client-shark.jpg" },
  { name: "warikoo", subs: "6M", img: "/media/client-warikoo.jpg" },
  { name: "Tech Burner", subs: "12M", img: "/media/client-techburner.jpg" },
  { name: "Dhruv Rathee", subs: "31M", img: "/media/client-dhruvrathee.jpg" },
];

function ClientCard({ client }) {
  return (
    <div className="group flex items-center gap-4 rounded-2xl border border-white/8 bg-[#0E0E12]/80 py-4 pl-4 pr-8">
      <div className="relative h-14 w-14 shrink-0 overflow-hidden rounded-full ring-1 ring-white/15 transition-all duration-500 group-hover:ring-[#FF3B30]/60">
        <img
          src={client.img}
          alt={`${client.name} — YouTube creator`}
          loading="lazy"
          className="h-full w-full object-cover grayscale transition-all duration-500 group-hover:scale-110 group-hover:grayscale-0"
        />
      </div>
      <div>
        <p className="font-display text-xl font-bold uppercase leading-none tracking-wide">{client.name}</p>
        <p className="mono-label mt-1.5 text-[10px] text-zinc-500">
          <span className="text-[#FF9500]">{client.subs}</span> subscribers
        </p>
      </div>
    </div>
  );
}

export default function ClientMarquee() {
  return (
    <section id="clients" className="relative border-y border-white/5 py-16 lg:py-24">
      <div className="wrap mb-10 flex items-end justify-between gap-6">
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.6 }}
          className="eyebrow mono-label text-[11px] text-zinc-400"
        >
          Clients I&apos;ve worked with
        </motion.p>
        <p className="mono-label hidden text-[10px] text-zinc-600 sm:block">Hover to pause</p>
      </div>

      <div className="marquee relative overflow-hidden" data-testid="clients-marquee">
        <div className="marquee-track gap-5 pr-5">
          {CLIENTS.map((c) => (
            <ClientCard key={`a-${c.name}`} client={c} />
          ))}
          {CLIENTS.map((c) => (
            <div key={`b-${c.name}`} aria-hidden="true">
              <ClientCard client={c} />
            </div>
          ))}
        </div>
        <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#070709] to-transparent" />
        <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#070709] to-transparent" />
      </div>
    </section>
  );
}
